// Keys match the raw uppercased API values from connectorStatusTypeCounts
export const CHARGER_STATUS = {
  AVAILABLE: "AVAILABLE",
  CHARGING: "CHARGING",
  FAULTED: "FAULTED",
  PREPARING: "PREPARING",
  FINISHING: "FINISHING",
  SUSPENDED_EVSE: "SUSPENDED_EVSE",
  SUSPENDED_EV: "SUSPENDED_EV",
  UNAVAILABLE: "UNAVAILABLE",
  OCCUPIED: "OCCUPIED",
  RESERVED: "RESERVED",
  OFFLINE: "OFFLINE",
};

export const STATUS_COLORS = {
  // Uppercase OCPP keys (v2 / stats API)
  [CHARGER_STATUS.AVAILABLE]: "#10b981",
  [CHARGER_STATUS.CHARGING]: "#2563eb",
  [CHARGER_STATUS.FAULTED]: "#ef4444",
  [CHARGER_STATUS.PREPARING]: "#f59e0b",
  [CHARGER_STATUS.FINISHING]: "#6366f1",
  [CHARGER_STATUS.SUSPENDED_EVSE]: "#f97316",
  [CHARGER_STATUS.SUSPENDED_EV]: "#fb923c",
  [CHARGER_STATUS.UNAVAILABLE]: "#6b7280",
  [CHARGER_STATUS.OCCUPIED]: "#0ea5e9",
  [CHARGER_STATUS.RESERVED]: "#a855f7",
  [CHARGER_STATUS.OFFLINE]: "#94a3b8",
  // Legacy lowercase keys (v1 buildChargerStatusDonut)
  online: "#10b981",
  offline: "#6b7280",
  charging: "#2563eb",
  faulted: "#ef4444",
  preparing: "#f59e0b",
};

export const STATUS_LABELS = {
  // Uppercase OCPP keys (v2 / stats API)
  [CHARGER_STATUS.AVAILABLE]: "Available",
  [CHARGER_STATUS.CHARGING]: "Charging",
  [CHARGER_STATUS.FAULTED]: "Faulted",
  [CHARGER_STATUS.PREPARING]: "Preparing",
  [CHARGER_STATUS.FINISHING]: "Finishing",
  [CHARGER_STATUS.SUSPENDED_EVSE]: "Suspended (EVSE)",
  [CHARGER_STATUS.SUSPENDED_EV]: "Suspended (EV)",
  [CHARGER_STATUS.UNAVAILABLE]: "Unavailable",
  [CHARGER_STATUS.OCCUPIED]: "Occupied",
  [CHARGER_STATUS.RESERVED]: "Reserved",
  [CHARGER_STATUS.OFFLINE]: "Offline",
  // Legacy lowercase keys (v1 buildChargerStatusDonut)
  online: "Available",
  offline: "Offline",
  charging: "Charging",
  faulted: "Faulted",
  preparing: "Preparing",
};

export const CHART_TITLE = "Charging Status";
export const TOOLTIP_BORDER = "1px solid #e5e7eb";

export const MOCK_STATUS_BREAKDOWN = [
  { status: CHARGER_STATUS.CHARGING, count: 42 },
  { status: CHARGER_STATUS.AVAILABLE, count: 35 },
  { status: CHARGER_STATUS.PREPARING, count: 20 },
  { status: CHARGER_STATUS.UNAVAILABLE, count: 21 },
  { status: CHARGER_STATUS.FAULTED, count: 10 },
];
